import { Box, Typography, Button, Container, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import themeColors from "../theme";
import Footer from "../components/Footer";

export default function AboutPage() {
    const navigate = useNavigate();
    const { teal } = themeColors;

    return (
        <Box sx={{ minHeight: "100vh", backgroundColor: "#f5f5f5", display: "flex", flexDirection: "column" }}>
            {/* Back to Home Button */}
            <Box sx={{ p: 3, borderBottom: "1px solid #e0e0e0", backgroundColor: "white" }}>
                <Container maxWidth="lg">
                    <Button
                        variant="text"
                        onClick={() => navigate("/")}
                        sx={{
                            color: teal,
                            fontSize: "1rem",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
                        }}
                    >
                        ← Back to Home
                    </Button>
                </Container>
            </Box>

            {/* Main Content */}
            <Container maxWidth="lg" sx={{ flexGrow: 1, py: 6 }}>
                <Box
                    sx={{
                        backgroundColor: "white",
                        borderRadius: 3,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                    }}
                >
                    <Grid container>
                        {/* Text Content */}
                        <Grid item xs={12} sx={{ p: { xs: 4, md: 6 } }}>
                            <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", mb: 4 }}>
                                About Us
                            </Typography>

                            <Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.8, mb: 3 }}>
                                <strong>OnCallCME is built exclusively for Emergency Medicine providers.</strong>
                            </Typography>

                            <Typography variant="body1" sx={{ fontSize: "1.05rem", lineHeight: 1.8, mb: 3 }}>
                                We created OnCallCME to simplify how Emergency Medicine clinicians manage continuing medical education. Our platform brings together CME fund tracking, CME credit tracking, secure document storage, a curated marketplace for high-quality CME resources, and timely email updates highlighting practice-changing guidelines in Emergency Medicine—all in one centralized system.
                            </Typography>

                            <Typography variant="body1" sx={{ fontSize: "1.05rem", lineHeight: 1.8, mb: 4 }}>
                                Emergency Medicine is fast-paced, high-stakes, and constantly evolving. CME should support clinicians—not slow them down. OnCallCME is designed to reduce administrative burden, improve access to high-quality education, and help clinicians stay current so they can focus on delivering excellent patient care.
                            </Typography>

                            {/* Image */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mt: 4,
                                }}
                            >
                                <Box
                                    component="img"
                                    src="/images/about-doctor.png"
                                    alt="OnCallCME Doctor"
                                    sx={{
                                        maxWidth: { xs: "80%", sm: "60%", md: "40%" },
                                        height: "auto",
                                    }}
                                />
                            </Box>
                        </Grid>

                    </Grid>
                </Box>
            </Container>

            {/* Footer */}
            <Footer />
        </Box>
    );
}
